import React from 'react';
import { radiansToDegrees } from '../..';
export const Rotate = ({ rotateY = 0, rotateX = 0, angle, gProps, children }) => {
    let rotatedDegrees = radiansToDegrees(angle);
    // I dunno how to tell you this...
    // ...but on FireFox if you rotate SVG <text> using <g> exactly by -45deg or 135deg,
    // it brakes space-time continuum and goes into exotic quantum superposition state...
    // Once observed by user, quantum state collapses and <text> may randomly appear or disappear
    if (rotatedDegrees % 45 === 0 && rotatedDegrees % 90 !== 0) {
        rotatedDegrees += 0.00001;
    }
    return (React.createElement("g", { transform: rotatedDegrees % 360 ? `rotate(${rotatedDegrees} ${rotateX} ${rotateY})` : undefined, ...gProps }, children));
};
//# sourceMappingURL=rotate.js.map